import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMobilePhoneRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 24 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.8 4.7c-.33 0-.6.27-.6.6v14.4c0 .33.27.6.6.6h8.4c.33 0 .6-.27.6-.6V5.3c0-.33-.27-.6-.6-.6H7.8Zm-2.4.6c0-1.324 1.077-2.4 2.4-2.4h8.4c1.324 0 2.4 1.076 2.4 2.4v14.4c0 1.324-1.076 2.4-2.4 2.4H7.8a2.402 2.402 0 0 1-2.4-2.4V5.3Zm5.1 11.4h3c.5 0 .9.401.9.9s-.4.9-.9.9h-3a.898.898 0 0 1-.9-.9c0-.499.402-.9.9-.9Z" })
});
export default SvgMobilePhoneRegularIcon;
